import React from 'react';
import { Col, Row, Space, Tooltip, Typography } from 'antd';
import { DeleteOutlined, ReloadOutlined } from '@ant-design/icons';
import AntCard from '../../../../components/AntCard/AntCard';
import AntInput from '../../../../components/AntInput/AntInput';
import useTextarea from './useTextarea';

const Textarea = ({ deleteFn, questionNumber, getData, data,operation }) => {

  const {
    onChangequestion,
    onChangeAnswer,
    onChangeDescription,
    resetFields,
    question,
    answer,
    description,
    resetDefaultFields
  } = useTextarea(getData, questionNumber,data,operation)
  return (
    <div style={{ paddingTop: '5%', overflow: 'hidden' }}>
      <Row align="bottom" gutter={16}>
        <AntCard title={
          <Row align="middle" gutter={16}>
            <Col><Typography>Question : {questionNumber + 1}</Typography></Col>
            <Col><Typography>type : Textarea</Typography></Col>
          </Row>
        }  style={{width:"100%"}}
          content={
            <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
              {operation==="preview"?<Typography><Typography.Text strong>{question}</Typography.Text></Typography>  
              :<AntInput placeholder={"Write Your Question"} label={"Question:"} value={question} onChange={onChangequestion} />}
              <AntInput inputType={"textarea"} placeholder={"Write The Correct Answer"} value={answer} textAreaRows={4} onChange={onChangeAnswer} />
              {operation==="preview"?"":<AntInput placeholder={"Add description"} label={"Description:"} value={description} onChange={onChangeDescription} />}
            </Space>
          }
          actions={[
            <Row justify="end" align="middle" gutter={[16, 16]}>
            {operation==="create"?
            <Col span={2}>
              <Tooltip placement="bottom" title={"Reset"}>
                <ReloadOutlined key="reset" style={{ fontSize: '18px', color: "#2C2C2C" }} onClick={resetFields} />
              </Tooltip>
            </Col>:operation==="update"?             
            <Col span={2}>
              <Tooltip placement="bottom" title={"Reset Default"}>
                <ReloadOutlined key="reset" style={{ fontSize: '18px', color: "#2C2C2C" }} onClick={resetDefaultFields} />
              </Tooltip>
            </Col>:""}
            {deleteFn?
              <Col span={2}>
                <Tooltip placement="bottom" title={"Delete"}>
                  <DeleteOutlined key="delete" style={{ fontSize: '18px', color: '#ff0000' }} onClick={() => { deleteFn(questionNumber) }} />
                </Tooltip>
              </Col>:""}
            </Row>
          ]} />
      </Row>
    </div>
  );
}

export default Textarea;
